import React, { useEffect } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Banner from '../sections/Banner/Banner';
import Services from '../sections/Services/Services';
import Emergency from '../sections/Emergency/Emergency';
import Expert from '../sections/Expert/Expert';
import Features from '../sections/Features/Features';
import Testimonial from '../sections/Testimonial/Testimonial';
import InstagramShowcase from '../components/InstagramShowcase/InstagramShowcase';
import Appointment from '../sections/Appointment/Appointment';
import Footer from '../sections/Footer/Footer';
import MetaHelmet from '../components/SEO/MetaHelmet';
import SchemaMarkup from '../components/SEO/SchemaMarkup';
import useAnalytics from '../hooks/useAnalytics';

const Home = () => {
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    setTimeout(() => {
      trackEvent('homepage_view');
    }, 100);
  }, [trackEvent]);

  return (
    <>
      <MetaHelmet pageName="home" />
      <SchemaMarkup type="dentist" />
      <Navbar />
      <Banner />
      <Testimonial />
      <InstagramShowcase />
      <Services />
      <Emergency />
      <Features />
      <Expert />
      <Appointment />
      <Footer />
    </>
  );
};

export default Home;